import { GET_ALL_NEW_NOTIFICATION_SUCCESS, GET_ALL_NOTIFICATION, GET_ALL_NOTIFICATION_FAILED, GET_ALL_NOTIFICATION_SUCCESS, GET_ARCHIVE_NOTIFICATION_SUCCESS, NOTIFICATION_DELETE, NOTIFICATION_STATUS_ARCHIVE_UPDATE, NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE, NOTIFICATION_STATUS_UPDATE } from "../../constants/notificationConstant"


const initialState = {
    isLoading: false,
    notificationAllData: {
        data: [],
        unread: 0,
        pagination: {
            page: 1
        }
    },
    unreadData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    archiveData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    error: null
}

const notificationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_NOTIFICATION:
            return {
                ...state,
                isLoading: true,
            }
        case GET_ALL_NOTIFICATION_SUCCESS:
            const isFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                notificationAllData: {
                    data: isFirstPage
                        ? action.payload.data
                        : [
                            ...state.notificationAllData.data,
                            ...action.payload.data.filter(newItem =>
                                !state.notificationAllData.data.some(existingItem => existingItem.id === newItem.id)
                            )
                        ],
                    unread: action.payload.unread,
                    pagination: action.payload.pagination
                }
            };

        case GET_ALL_NEW_NOTIFICATION_SUCCESS:
            const isFirstUnreadPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                unreadData: {
                    ...state.unreadData,
                    data: isFirstUnreadPage
                        ? action.payload.data
                        : [
                            ...state.unreadData.data,
                            ...action.payload.data
                        ],
                    pagination: action.payload.pagination
                }

            };
        case GET_ARCHIVE_NOTIFICATION_SUCCESS:
            const isFirstArPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                archiveData: {
                    data: isFirstArPage
                        ? action.payload.data
                        : [
                            ...state.archiveData.data,
                            ...action.payload.data.filter(newItem =>
                                !state.archiveData.data.some(existingItem => existingItem.id === newItem.id)
                            )
                        ],
                    unread: action.payload.unread,

                    pagination: action.payload.pagination
                }

            };
        case NOTIFICATION_STATUS_UPDATE:
            // Get targeted object by ID
            const targetId = action.payload.id;
            // Update and return state
            return {
                ...state,
                isLoading: false,
                notificationAllData: {
                    ...state.notificationAllData,
                    data: state.notificationAllData.data.map(notification =>
                        notification.id === targetId
                            ? { ...notification, status: 'read' }
                            : notification
                    ),
                    unread: action.payload.unread,
                }
            };
        case NOTIFICATION_STATUS_ARCHIVE_UPDATE:
            // Get targeted object by ID
            const archiveId = action.payload.id;
            const arData = action.payload.data;
            
            // Safely filter notifications with null checks
            const updatedNotifications = state.notificationAllData?.data 
                ? state.notificationAllData.data.filter(notification => notification.id !== archiveId)
                : [];
                
            const updatedUnNotifications = state.unreadData?.data
                ? state.unreadData.data.filter(notification => notification.id !== archiveId)
                : [];

            return {
                ...state,
                isLoading: false,
                notificationAllData: {
                    ...state.notificationAllData,
                    data: updatedNotifications
                },
                unreadData: {
                    ...state.unreadData,
                    data: updatedUnNotifications
                },
                archiveData: {
                    ...state.archiveData,
                    data: state.archiveData?.data && state.archiveData.data.length > 0 
                        ? [arData, ...state.archiveData.data]
                        : arData ? [arData] : []
                }
            };
        case NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE:
            // Get targeted object by ID
            const unArchiveId = action.payload.id;
            const unArData = action.payload.data;
            // Update and return state
            const newNotifications = state.archiveData.data.filter(notification =>
                notification.id !== unArchiveId
            );
            return {
                ...state,
                isLoading: false,
                archiveData: {
                    ...state.archiveData,
                    data: newNotifications
                },
                notificationAllData: {
                    data: [
                        unArData,
                        ...state.notificationAllData.data
                    ]
                }
            };

        case NOTIFICATION_DELETE:
            // Get targeted object by ID
            const deleteId = action.payload.id;
            
            // Safely filter notifications with null checks
            const deletedAllNotifications = state.notificationAllData?.data
                ? state.notificationAllData.data.filter(notification => notification.id !== deleteId)
                : [];
                
            const deletedArNotifications = state.archiveData?.data
                ? state.archiveData.data.filter(arNotification => arNotification.id !== deleteId)
                : [];
                
            const deletedNewNotifications = state.unreadData?.data
                ? state.unreadData.data.filter(unNotification => unNotification.id !== deleteId)
                : [];

            return {
                ...state,
                isLoading: false,
                notificationAllData: {
                    ...state.notificationAllData,
                    data: deletedAllNotifications
                },
                archiveData: {
                    ...state.archiveData,
                    data: deletedArNotifications
                },
                unreadData: {
                    ...state.unreadData,
                    data: deletedNewNotifications
                }
            };

        case GET_ALL_NOTIFICATION_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        default:
            return state;
    }
}

export default notificationDataReducer;